import apiClient from './apiClient.js';

export const updateGathering = async (
    gathering_id,
    owner_id,
    name,
    image_url
) => {
    const session_url = '/gathering';
    try {
        const response = await apiClient.patch(session_url, {
            gathering_id: gathering_id,
            owner_id: owner_id,
            name: name,
            image_url: image_url,
        });
        return response.data;
    } catch (err) {
        console.error(err.message);
        console.error(err.response);
        throw err;
    }
};
